import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar  from './components/layout/Navbar';
import Footer  from './components/layout/Footer';
import Home    from './pages/Home';
import Services from './pages/Services';
import Education from './pages/Education';
import Jobs    from './pages/Jobs';
import Tourism  from './pages/Tourism';
import About   from './pages/About';
import Contact  from './pages/Contact';
import Overview from './pages/Overview';
import PrivacyPolicy from './pages/PrivacyPolicy';
import './styles/globals.css';

function NotFound() {
  return (
    <div className="page-wrapper" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '70vh', flexDirection: 'column', gap: '1rem', textAlign: 'center', padding: '2rem' }}>
      <div style={{ fontSize: '4rem' }}>🌏</div>
      <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', color: 'var(--navy)' }}>Page Not Found</h1>
      <p style={{ color: 'var(--text-muted)' }}>The page you're looking for doesn't exist.</p>
      <a href="/" className="btn btn--primary">Go Home</a>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <main>
        <Routes>
          <Route path="/"          element={<Home />}      />
          <Route path="/services"  element={<Services />}  />
          <Route path="/education" element={<Education />} />
          <Route path="/jobs"      element={<Jobs />}      />
          <Route path="/tourism"   element={<Tourism />}   />
          <Route path="/about"     element={<About />}     />
          <Route path="/contact"   element={<Contact />}   />
          <Route path="/overview"  element={<Overview />}  />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*"          element={<NotFound />}  />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}
